module.exports = __webpack_public_path__ + "static/media/php.cdf5b5e1.svg";